import { SearchUrlParamBuilder } from '@/core/utils'
import axios from 'axios'

const URL_PATH = 'api/atas'

class PartesEnvolvidasApiClient {
	async buscarPorFiltro(idAta, pagingAndSorting) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/${idAta}/partes-envolvidas`,
			pagingAndSorting,
		}).build()

		return await axios.get(url)
	}

	async criar(idAta, parteEnvolvida) {
		return await axios.post(`${URL_PATH}/${idAta}/partes-envolvidas`, parteEnvolvida)
	}

	async validar(idAta, { cnpj, codigoUnidadeCompradora }) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/${idAta}/partes-envolvidas/validar`,
			filters: { cnpj, codigoUnidadeCompradora },
		}).build()

		return await axios.get(url)
	}
}

export default new PartesEnvolvidasApiClient()
